var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { getRgb, getBackground, checkmarkContrast, subtletyContrast, getContrastColor, isLuminanceBelow, } from './colors';
import classNames from 'classnames';
import { styled } from '../../themeCustomink';
import { DogEarSwatch } from './DogEarSwatch';
import { SubtleSwatch } from './SubtleSwatch';
import { CheckIcon } from '../../icons/CheckIcon';
import { NoinkIcon } from '../../icons/NoinkIcon';
export var ColorSwatchStyles = styled('div', {
    name: 'pigment-colorswatch',
})({
    boxSizing: 'border-box',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    display: 'inline-block',
    height: '1.5rem',
    width: '1.5rem',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    transition: 'all 150ms ease',
    boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
    '&::before': {
        content: '""',
        boxSizing: 'border-box',
        borderRadius: '0.25rem',
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
    },
    '&.swatch-outline': {
        '&::before': {
            border: '1px solid #e3e3e3',
            mixBlendMode: 'darken',
        },
    },
    '&:hover': {
        boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.2)',
    },
    '&.pigment-colorswatch-large': {
        width: '2rem',
        height: '2rem',
        '.pigment-colorswatch-check': {
            width: '1.5rem',
            height: '1.5rem',
        },
        '.pigment-colorswatch-noink': {
            maxWidth: '2rem',
        },
    },
    '.pigment-colorswatch-check': {
        position: 'absolute',
        width: '1rem',
        height: '1rem',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    '.pigment-colorswatch-noink': {
        position: 'absolute',
        width: '100%',
        height: 'auto',
        maxWidth: '1.5rem',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
});
var defaultFunction = function () {
    /* default function for optional props */
};
export var ColorSwatch = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.displayOnly, displayOnly = _b === void 0 ? false : _b, _c = _a.dogEar, dogEar = _c === void 0 ? false : _c, focused = _a.focused, selected = _a.selected, _d = _a.size, size = _d === void 0 ? 'small' : _d, special = _a.special, _e = _a.subtlety, subtlety = _e === void 0 ? false : _e, sx = _a.sx, _f = _a.tabIndex, tabIndex = _f === void 0 ? 0 : _f, trimRgb = _a.trimRgb, _g = _a.onFocus, onFocus = _g === void 0 ? defaultFunction : _g, _h = _a.onClick, onClick = _h === void 0 ? defaultFunction : _h, _j = _a.onMouseEnter, onMouseEnter = _j === void 0 ? defaultFunction : _j, _k = _a.onMouseLeave, onMouseLeave = _k === void 0 ? defaultFunction : _k, props = __rest(_a, ["className", "color", "displayOnly", "dogEar", "focused", "selected", "size", "special", "subtlety", "sx", "tabIndex", "trimRgb", "onFocus", "onClick", "onMouseEnter", "onMouseLeave"]);
    var rgb = getRgb(color);
    var trimColor = getRgb(trimRgb);
    var colorSwatchClass = classNames(className, {
        'pigment-colorswatch-large': size === 'large',
        'pigment-colorswatch-selected': selected || focused,
        'swatch-outline': !isLuminanceBelow(rgb, 227) ||
            (trimColor && !isLuminanceBelow(trimColor, 227)),
    });
    return (React.createElement(ColorSwatchStyles, __assign({ "data-testid": "ColorSwatch color-".concat(color), tabIndex: displayOnly ? -1 : tabIndex, sx: __assign(__assign(__assign(__assign({}, getBackground(size, color, trimRgb, special)), (displayOnly && { pointerEvents: 'none' })), (focused && {
            outline: "1px solid ".concat(designTokens.color.shade.white.value),
            boxShadow: "0px 0px 0px 2px ".concat(designTokens.color.blue.default.value, " !important"),
        })), sx) }, props, { className: colorSwatchClass, onBlur: onFocus, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }),
        color === undefined && special === undefined && (React.createElement(NoinkIcon, { className: "pigment-colorswatch-noink" })),
        selected ? (React.createElement(CheckIcon, { "data-testid": "CheckIcon-".concat(color), sx: {
                color: checkmarkContrast(rgb, special),
            }, className: "pigment-colorswatch-check" })) : null,
        subtlety ? (React.createElement(SubtleSwatch, { contrastColor: subtletyContrast(rgb, special) })) : null,
        dogEar ? (React.createElement(DogEarSwatch, { contrast: getContrastColor('#000', rgb) })) : null));
};
//# sourceMappingURL=ColorSwatch.js.map